import { useMemo } from 'react'
import { Helmet } from 'react-helmet'
import { useVenueDataContext } from './VenueDataLoader'

export function AppMeta() {
  const {
    templateData,
    cookieConsentCustomInclude,
    analyticsSettings: { blockSearchEngine = false },
  } = useVenueDataContext()

  const customCookieConsentScript = useMemo(() => {
    if (!cookieConsentCustomInclude) {
      return undefined
    }
    return <script dangerouslySetInnerHTML={{ __html: cookieConsentCustomInclude }} /> // I hate this, it is dangerous
  }, [cookieConsentCustomInclude])

  const blockSearchEngineMeta = useMemo(() => {
    if (!blockSearchEngine) {
      return null
    }
    return <meta name="robots" content="noindex" />
  }, [blockSearchEngine])

  return (
    <Helmet>
      <title>{templateData.title}</title>
      <meta property="og:url" content={templateData.metaOgUrl} />
      <meta property="og:title" content={templateData.metaOgTitle} />
      <meta property="og:description" content={templateData.metaOgDescription} />
      <meta name="twitter:description" content={templateData.metaTwitterDescription} />
      <meta name="twitter:title" content={templateData.metaTwitterTitle} />
      {customCookieConsentScript}
      {blockSearchEngineMeta}
    </Helmet>
  )
}
